// Veg / non-veg / not-applicable classification for diet markers.

// Food-type values that mean "no veg/non-veg marking" (e.g. "NA" on drinks).
const NOT_APPLICABLE = new Set(['na', 'n/a', 'none', 'notapplicable', 'nil']);

const normalize = (value) =>
  String(value ?? '')
    .toLowerCase()
    .replace(/[\s_-]/g, '');

/**
 * @param {string|undefined|null} value food-type slug, name or dietary tag
 * @returns {'veg'|'nonveg'|'na'|null} null when there is no value at all
 */
export function dietKind(value) {
  const key = normalize(value);
  if (!key) return null;
  if (NOT_APPLICABLE.has(key)) return 'na';
  if (key.startsWith('veg')) return 'veg';
  return 'nonveg';
}

/** Accessible label for a diet marker. */
export function dietLabel(kind) {
  if (kind === 'veg') return 'Vegetarian';
  if (kind === 'na') return 'Not applicable';
  return 'Non-vegetarian';
}
